export default "__VITE_ASSET__f292a47b__"